/*
 * Initialize LumApps Context refresh token functions
 */

/**
 * Refresh LumApps token via cookie
 * @returns {Promise<string>}
 */
async function refreshToken() {
    const response = await fetch('/service/user/token', { method: 'POST', credentials: 'include' });
    const data = await response.json();
    const { status, token } = data;
    if (!status || !response.ok || !token) {
        throw new Error({ response, data });
    }
    window.LumappsContext.token = token;
    window.USER_ACCESS_TOKEN = token;
    return token;
}

// Cache promise to make sure we only do one request at a time.
let tokenPromise = null;

/**
 * LumApps Context refresh token
 * @returns {Promise<string>}
 */
window.LumappsContext.refreshToken = () => {
    if (!tokenPromise) {
        tokenPromise = refreshToken().finally(() => {
            tokenPromise = null;
        });
    }
    return tokenPromise;
};

if (window.lumapps) {
    /**
     * LumApps Customization API refresh token
     * @returns {Promise<{data: {token: string}; status: boolean}>}
     */
    window.lumapps.refreshToken = async () => {
        const token = await window.LumappsContext.refreshToken();
        // Wrapping data to be backward-compatible with the previously returned AxiosResponse
        return { status: 200, data: { token } };
    };
}
